/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:17:33
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/parse.js
 */
export default {
    // parse
    parse: {
        copyLink: true,
        errorImg: '',
        lazyLoad: false,
        loadingImg: '',
        pauseVideo: true,
        previewImg: true,
        setTitle: true,
        showImgMenu: true
    }
}
